import styles from './PopoverMenu.module.scss'
import { Arrow } from '@app/icons'
import { Popover } from 'antd'
import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'

export const PopoverMenu = memo(({ actions = [], handleClickItem, content, zIndex = 50 }) => {
	const { t } = useTranslation()

	const list = useMemo(
		() =>
			actions?.map((item, index) => {
				return (
					<li
						key={item?.action}
						onClick={(e) => {
							e.stopPropagation()
							if (!item?.disabled) {
								handleClickItem(item.action)
							}
						}}
						className={cl({
							[styles.disabled]: item.disabled,
						})}
					>
						<div>{item.icon}</div>
						{item?.title}
					</li>
				)
			}),
		[t],
	)

	return (
		<Popover
			placement="bottomRight"
			overlayClassName={'actions'}
			zIndex={zIndex}
			trigger="click"
			content={<ul className={`${styles.list} `}>{list}</ul>}
		>
			<button type={'button'} onClick={e => e.stopPropagation()} className={styles.buttonContainer}>
				{
					content || (
						<div className={styles.dropdownButton}>
							{t('select_pls')}
							<Arrow className={styles.icon} />
						</div>
					)
				}
			</button>
		</Popover>
	)
})
